/**
 * Un turbo-frame qui change de contenu le fait dans une View Transition du navigateur
 * (`document.startViewTransition`, crochet documenté `turbo:before-frame-render`) : les
 * éléments qui portent le même `view-transition-name` avant et après s'animent de l'un à
 * l'autre, le reste se fond. Exemple : le contour choisi de « Quel format ? » grossit vers le
 * cadre de l'éditeur. Un navigateur sans l'API change sans animer.
 *
 * Opt-in : seuls les frames marqués `data-view-transition` (document_editor : l'étape du
 * format puis l'éditeur) s'animent. Les autres — rechargés à chaque sauvegarde (bande de
 * pages, toolbox) — ne doivent jamais figer la page dans une transition.
 *
 * Même opt-in pour un Turbo Stream (`data-view-transition` sur le <turbo-stream>) : une carte
 * qu'on retire d'une grille s'efface et les autres glissent à leur place, si chacune porte son
 * `view-transition-name`.
 *
 * Un contenu qui se place en JS après son rendu (le cadre de l'éditeur, calé par fabric)
 * porte `data-settles` et émet `frame:settled` une fois placé : la transition l'attend, au
 * plus 500 ms. Les durées et courbes sont en CSS (::view-transition-*).
 */
document.addEventListener("turbo:before-frame-render", (event) => {
  if (typeof document.startViewTransition !== "function") return;
  if (!event.target.hasAttribute("data-view-transition")) return;

  const render = event.detail.render;
  event.detail.render = (currentElement, newElement) =>
    document.startViewTransition(async () => {
      await render(currentElement, newElement);
      await settled(currentElement);
    }).updateCallbackDone;
});

document.addEventListener("turbo:before-stream-render", (event) => {
  if (typeof document.startViewTransition !== "function") return;
  if (!event.target.hasAttribute("data-view-transition")) return;

  const render = event.detail.render;
  event.detail.render = (streamElement) =>
    document.startViewTransition(() => render(streamElement)).updateCallbackDone;
});

function settled(frame) {
  if (!frame.querySelector("[data-settles]")) return;

  return new Promise((resolve) => {
    frame.addEventListener("frame:settled", resolve, { once: true });
    setTimeout(resolve, 500);
  });
}
